// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file personalcontext/personalcontext.proto (package lvdr.v2.personalcontext, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file personalcontext/personalcontext.proto.
 */
export const file_personalcontext_personalcontext: GenFile = /*@__PURE__*/
  fileDesc("CiVwZXJzb25hbGNvbnRleHQvcGVyc29uYWxjb250ZXh0LnByb3RvEhdsdmRyLnYyLnBlcnNvbmFsY29udGV4dCIyCg9QZXJzb25hbENvbnRleHQSDAoEdGV4dBgBIAEoCRIRCgltYXhfY2hhcnMYAiABKAUiGwoZR2V0UGVyc29uYWxDb250ZXh0UmVxdWVzdCIsChxVcGRhdGVQZXJzb25hbENvbnRleHRSZXF1ZXN0EgwKBHRleHQYASABKAkiVAoXUGVyc29uYWxDb250ZXh0UmVzcG9uc2USOQoHY29udGV4dBgBIAEoCzIoLmx2ZHIudjIucGVyc29uYWxjb250ZXh0LlBlcnNvbmFsQ29udGV4dEIwWi5naXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvcGVyc29uYWxjb250ZXh0YgZwcm90bzM");

/**
 * @generated from message lvdr.v2.personalcontext.PersonalContext
 */
export type PersonalContext = Message<"lvdr.v2.personalcontext.PersonalContext"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * max_chars rides the wire so the frontend counter and the server-side cap
   * cannot drift. Authoritative value is personalcontext.MaxChars.
   *
   * @generated from field: int32 max_chars = 2;
   */
  maxChars: number;
};

/**
 * Describes the message lvdr.v2.personalcontext.PersonalContext.
 * Use `create(PersonalContextSchema)` to create a new message.
 */
export const PersonalContextSchema: GenMessage<PersonalContext> = /*@__PURE__*/
  messageDesc(file_personalcontext_personalcontext, 0);

/**
 * @generated from message lvdr.v2.personalcontext.GetPersonalContextRequest
 */
export type GetPersonalContextRequest = Message<"lvdr.v2.personalcontext.GetPersonalContextRequest"> & {
};

/**
 * Describes the message lvdr.v2.personalcontext.GetPersonalContextRequest.
 * Use `create(GetPersonalContextRequestSchema)` to create a new message.
 */
export const GetPersonalContextRequestSchema: GenMessage<GetPersonalContextRequest> = /*@__PURE__*/
  messageDesc(file_personalcontext_personalcontext, 1);

/**
 * @generated from message lvdr.v2.personalcontext.UpdatePersonalContextRequest
 */
export type UpdatePersonalContextRequest = Message<"lvdr.v2.personalcontext.UpdatePersonalContextRequest"> & {
  /**
   * Empty string clears the document. Unlike the proto3 "absent vs empty" trap
   * elsewhere in this codebase, there is no ambiguity here: this is a full
   * replace of a single scalar, so "" unambiguously means "no personal context".
   *
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.personalcontext.UpdatePersonalContextRequest.
 * Use `create(UpdatePersonalContextRequestSchema)` to create a new message.
 */
export const UpdatePersonalContextRequestSchema: GenMessage<UpdatePersonalContextRequest> = /*@__PURE__*/
  messageDesc(file_personalcontext_personalcontext, 2);

/**
 * Shared response for both get and update — the server always echoes the stored
 * document, so the client never has to guess what was persisted.
 *
 * @generated from message lvdr.v2.personalcontext.PersonalContextResponse
 */
export type PersonalContextResponse = Message<"lvdr.v2.personalcontext.PersonalContextResponse"> & {
  /**
   * @generated from field: lvdr.v2.personalcontext.PersonalContext context = 1;
   */
  context?: PersonalContext | undefined;
};

/**
 * Describes the message lvdr.v2.personalcontext.PersonalContextResponse.
 * Use `create(PersonalContextResponseSchema)` to create a new message.
 */
export const PersonalContextResponseSchema: GenMessage<PersonalContextResponse> = /*@__PURE__*/
  messageDesc(file_personalcontext_personalcontext, 3);

